export default __webpack_public_path__ + "static/media/ACCircuitsImg.70d12230.jpg";